import Vue from 'vue'

export default {
  methods: {
    create2DArray (rows) {
      let arr = []
      for (var i = 0; i < rows; i++) {
        arr[i] = []
      }
      return arr
    },
    prepareStakesForLess: function (stakes) {
      let result = []
      let mapByStakeEnumLess = {}
      let filteredStakesLess = stakes.filter(e => e.StakeEnum === 11)
      filteredStakesLess.forEach(element => {
        mapByStakeEnumLess[element.StakeTypeEnum] = element
      })
      Vue.set(mapByStakeEnumLess[11], 'Title', '1.5')
      Vue.set(mapByStakeEnumLess[11], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumLess[11], 'TableSubname', 'less')
      result.push(mapByStakeEnumLess[11])

      Vue.set(mapByStakeEnumLess[12], 'Title', '2.5')
      Vue.set(mapByStakeEnumLess[12], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumLess[12], 'TableSubname', 'less')
      result.push(mapByStakeEnumLess[12])

      Vue.set(mapByStakeEnumLess[13], 'Title', '3.5')
      Vue.set(mapByStakeEnumLess[13], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumLess[13], 'TableSubname', 'less')
      result.push(mapByStakeEnumLess[13])

      Vue.set(mapByStakeEnumLess[14], 'Title', '4.5')
      Vue.set(mapByStakeEnumLess[14], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumLess[14], 'TableSubname', 'less')
      result.push(mapByStakeEnumLess[14])
      return result
    },
    prepareStakesForMore: function (stakes) {
      let result = []
      let mapByStakeEnumMore = {}
      let filteredStakesMore = stakes.filter(e => e.StakeEnum === 12)
      filteredStakesMore.forEach(element => {
        mapByStakeEnumMore[element.StakeTypeEnum] = element
      })
      Vue.set(mapByStakeEnumMore[11], 'Title', '1.5')
      Vue.set(mapByStakeEnumMore[11], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumMore[11], 'TableSubname', 'more')
      result.push(mapByStakeEnumMore[11])

      Vue.set(mapByStakeEnumMore[12], 'Title', '2.5')
      Vue.set(mapByStakeEnumMore[12], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumMore[12], 'TableSubname', 'more')
      result.push(mapByStakeEnumMore[12])

      Vue.set(mapByStakeEnumMore[13], 'Title', '3.5')
      Vue.set(mapByStakeEnumMore[13], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumMore[13], 'TableSubname', 'more')
      result.push(mapByStakeEnumMore[13])

      Vue.set(mapByStakeEnumMore[14], 'Title', '4.5')
      Vue.set(mapByStakeEnumMore[14], 'TableName', 'sum_of_goals')
      Vue.set(mapByStakeEnumMore[14], 'TableSubname', 'more')
      result.push(mapByStakeEnumMore[14])
      return result
    },
    prepareStakesForCorrectScore: function (stakes) {
      let rowOne = []
      let mapByStakeEnum = {}
      let filteredStakes = stakes.filter(e => e.StakeTypeEnum === 100)
      filteredStakes.forEach(element => {
        mapByStakeEnum[element.StakeEnum] = element
      })
      Vue.set(mapByStakeEnum[110], 'Title', '1:0')
      Vue.set(mapByStakeEnum[110], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[110])

      Vue.set(mapByStakeEnum[120], 'Title', '2:0')
      Vue.set(mapByStakeEnum[120], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[120])

      Vue.set(mapByStakeEnum[121], 'Title', '2:1')
      Vue.set(mapByStakeEnum[121], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[121])

      Vue.set(mapByStakeEnum[101], 'Title', '0:1')
      Vue.set(mapByStakeEnum[101], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[101])

      Vue.set(mapByStakeEnum[102], 'Title', '0:2')
      Vue.set(mapByStakeEnum[102], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[102])

      Vue.set(mapByStakeEnum[112], 'Title', '1:2')
      Vue.set(mapByStakeEnum[112], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[112])

      Vue.set(mapByStakeEnum[100], 'Title', '0:0')
      Vue.set(mapByStakeEnum[100], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[100])

      Vue.set(mapByStakeEnum[111], 'Title', '1:1')
      Vue.set(mapByStakeEnum[111], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[111])

      Vue.set(mapByStakeEnum[122], 'Title', '2:2')
      Vue.set(mapByStakeEnum[122], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[122])

      Vue.set(mapByStakeEnum[199], 'Title', this.$t('other'))
      Vue.set(mapByStakeEnum[199], 'TableName', 'correct_score')
      rowOne.push(mapByStakeEnum[199])
      return [rowOne]
    },
    prepareStakesForFullTimeAndHalfTime: function (type, stakes) {
      let StakeEnum = type
      let tableName = type === 1 ? 'half_time' : 'full_time'
      let rowOne = []
      let rowTwo = []
      let mapByStakeEnum = {}

      let filteredStakes = stakes.filter(element => element.StakeTypeEnum === StakeEnum)
      filteredStakes.forEach(element => {
        mapByStakeEnum[element.StakeEnum] = element
      })

      Vue.set(mapByStakeEnum[1], 'Title', '1')
      Vue.set(mapByStakeEnum[1], 'TableName', tableName)
      Vue.set(mapByStakeEnum[1], 'TableSubname', '')
      rowOne.push(mapByStakeEnum[1])

      Vue.set(mapByStakeEnum[3], 'Title', 'X')
      Vue.set(mapByStakeEnum[3], 'TableName', tableName)
      Vue.set(mapByStakeEnum[3], 'TableSubname', '')
      rowOne.push(mapByStakeEnum[3])

      Vue.set(mapByStakeEnum[2], 'Title', '2')
      Vue.set(mapByStakeEnum[2], 'TableName', tableName)
      Vue.set(mapByStakeEnum[2], 'TableSubname', '')
      rowOne.push(mapByStakeEnum[2])

      Vue.set(mapByStakeEnum[4], 'Title', 'X1')
      Vue.set(mapByStakeEnum[4], 'TableName', tableName)
      Vue.set(mapByStakeEnum[4], 'TableSubname', '')
      rowTwo.push(mapByStakeEnum[4])

      Vue.set(mapByStakeEnum[6], 'Title', '12')
      Vue.set(mapByStakeEnum[6], 'TableName', tableName)
      Vue.set(mapByStakeEnum[6], 'TableSubname', '')
      rowTwo.push(mapByStakeEnum[6])

      Vue.set(mapByStakeEnum[5], 'Title', 'X2')
      Vue.set(mapByStakeEnum[5], 'TableName', tableName)
      Vue.set(mapByStakeEnum[5], 'TableSubname', '')
      rowTwo.push(mapByStakeEnum[5])
      return [rowOne, rowTwo]
    }
  }
}
